import { render, staticRenderFns } from "./registerEquipe.vue?vue&type=template&id=50be3d97&scoped=true&"
import script from "./registerEquipe.vue?vue&type=script&lang=js&"
export * from "./registerEquipe.vue?vue&type=script&lang=js&"
import style0 from "./registerEquipe.vue?vue&type=style&index=0&id=50be3d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be3d97",
  null
  
)

export default component.exports